module.exports = __webpack_public_path__ + "static/media/AO.df5cf8ba.png";